import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { TaskState } from '../../../interfaces/common/async_tasks';

interface AsyncTaskProgressBarProps {
  progress: number;
  status: TaskState;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  processingText?: string;
}

const AsyncTaskProgressBar: React.FC<AsyncTaskProgressBarProps> = ({
  progress,
  status,
  color,
  processingText = 'Processing...'
}) => {
  const progressColor = color || (
    status === 'FAILED'
      ? 'error'
      : status === 'COMPLETED'
      ? 'success'
      : 'primary'
  );

  const statusText = status === 'STARTED' ? processingText : status;

  return (
    <Box sx={{ mb: 1 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        color={progressColor}
        sx={{ height: 8, borderRadius: 4 }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          {statusText}
        </Typography>
        <Typography variant="caption" fontWeight="bold">
          {progress}%
        </Typography>
      </Box>
    </Box>
  );
};

export default AsyncTaskProgressBar;

